import React from 'react'
import SectionSintomas from '../components/SectionSintomas/SectionSintomas'

function Sintomas() {
  return (
    <div>
      <SectionSintomas />
    </div>
  )
}

export default Sintomas
